/* eslint-disable @cspell/spellchecker */
const legacyGrowthspacesSlugProd = [
  "akshara-international-school-l-b-nagar",
  "akshara-international-school-a-s-rao-nagar",
  "akshara-international-school-pocharam",
  "akshara-international-school-nadergul",
  "akshara-international-school-kismatpur",
  "akshara-international-school-suchitra",
  "akshara-centre-for-excellence",
  "akshara-international-schools-leadership",
  "sairam-group-of-institutions",
  "akshara-international-school-karimnagar",
  "suraasa-sample-schoool",
  "akshara-international-school-kukatpally",
  "internal-organization",
  "national-council-for-teacher-education",
  "cbse-skill-education",
  "internal-test-organization",
  "school-of-scientific-innovation",
  "premium-international-school",
  "clarion-school",
  "almaharat-private-school",
  "ajman-american-private-school",
  "yasmina-british-academy",
  "glendale",
  "ajman-academy",
  "ajyal-international-school-mbz",
  "aldhraa-school",
  "al-ittihad-private-school-jumeira",
  "british-international-private-school",
  "woodlem-british-school",
  "beaconhouse-group",
  "taalem",
  "gems-rak",
  "philadelphia-private-school",
  "nahda-schools",
  "noya-british-school",
  "school-of-modern-skills",
  "royal-private-english-school",
  "northside-charter-high-school",
  "delhi-private-school-llc",
  "american-international",
  "demo-suraasa-75",
  "shri-ramkrishna-harikrishna-academy",
  "rotary-club-of-madras-east",
  "developers-united",
  "kamala-niketan-montessori-school",
  "suraasa-partnerships-growthspace",
  "rocketship-public-schools",
  "phinma-education",
  "srm-welkin",
  "amber-international-school",
  "new-jersey-association-of-independent-schools",
  "singhgad-city-school-pune",
  "shri-ram-global-school",
  "clara-global-school",
  "swiss-cottage-school",
  "legacy-growthspace-10",
  "legacy-growthspace-9",
  "legacy-growthspace-8",
  "legacy-growthspace-7",
  "legacy-growthspace-6",
  "legacy-growthspace-5",
  "legacy-growthspace-4",
  "legacy-growthspace-3",
  "legacy-growthspace-2",
  "legacy-growthspace-1",
]

export const isLegacyGrowthspace = (slug: string | null | undefined) =>
  legacyGrowthspacesSlugProd.includes(slug || "")
